export default {
  title: 'changePassword',
  type: 'object',
  properties: {
    previousPassword: {
      type: 'string',
      title: 'Obecne hasło',
      fieldRequired: 'true',
      minLength: 8
    },
    password: {
      type: 'string',
      title: 'Nowe hasło',
      fieldRequired: 'true',
      minLength: 8
    },
    repeatPassword: {
      type: 'string',
      title: 'Powtórz nowe hasło',
      fieldRequired: 'true',
      minLength: 8,
      validFunc: 'this.password === this.repeatPassword ? true : "Hasła nie pasują do siebie"'
    }
  }
};
